import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cad-import-icon',
  templateUrl: './cad-import-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CadImportIconComponent {}
